import React, { useEffect, useRef, useState } from "react";
import Sidebar from "./Sidebar";
import "./Main.css";
import Header from "./Header";
import Plan from "./Plan";
import { decryptData } from "../../common/encryptAnddecryptData";
import {
  ChatGptHistory,
  getCategory,
  getCurrentPointsData,
  getMessage,
  getSubCategory,
  IMAGE_URL,
} from "../../Api/commonAPI";
import { combineCategoriesWithSubcategories, plans } from "../../common/common";
import Warning from "./Warning";
import PointHistory from "./PointHistory";
import PurchaseHistory from "./PurchaseHistory";
import { PiPaperclip } from "react-icons/pi";


const ChatGPTMain = () => {
  const scrollRef = useRef(null);
  const fileInputRef = useRef(null); // Added: File input reference
  const [history, setHistory] = useState();
  const [sidebar, setSidebar] = useState(window.innerWidth >= 1080);
  const [textarea, setTextarea] = useState("");
  const [points, setPoints] = useState("");
  const [showModal, setShowModal] = useState(false);
  let user = null;
  try {
    const userString = sessionStorage.getItem("user");
    if (userString) {
      user = JSON.parse(userString);
    }
  } catch (error) {
    console.error("Error parsing user data from sessionStorage:", error);
  }
  const userDetails = user?.data ? decryptData(user.data) : null;
  const token = user?.token;
  const [selected, setSelected] = useState(plans.find((p) => p.selected));
  const [shouldRefetchPoints, setShouldRefetchPoints] = useState(true);
  const [IsError, setIsError] = useState(false);
  const [IsPurchase, setIsPurchase] = useState(false);
  const [IsPointHistory, setIsPointHistory] = useState(false);
  const [selectHistory, setSelectHistory] = useState(null);
  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [categoryDropdown, setCategoryDropdown] = useState([]);

  // Added: File attachment state
  const [attachedFile, setAttachedFile] = useState(null);
  const [fileContent, setFileContent] = useState("");

  const [selectedOption, setSelectedOption] = useState({
    value: "category-2",
    label: "Legal",
    isSubcategory: false,
    categoryId: 2,
    SubCategoryID: 0,
  });

  const [value, setValue] = useState([
    {
      prompt: "",
      content: "",
      fileData: null, // Added: File data for each message
    },
  ]);

  const fetchCategory = async () => {
    try {
      const res = await getCategory();
      const decryptedCategory = await decryptData(res.data.data);
      setCategory(decryptedCategory);
    } catch (error) {
      console.error("error", error);
    }
  };

  const fetchSubCategory = async () => {
    try {
      const res = await getSubCategory();
      if (res?.data?.data) {
        const decryptedSubCategory = await decryptData(res.data.data);
        if (decryptedSubCategory) {
          setSubCategory(decryptedSubCategory);
        }
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const fetchPointsData = async () => {
    try {
      if (!userDetails || !token) return;
      const response = await getCurrentPointsData(userDetails, token);
      const data = response.data;
      if (data?.data) {
        const decrypted = decryptData(data.data);
        if (decrypted) {
          setPoints(decrypted?.CurrentPoints);
        }
      }
    } catch (error) {
      console.error("Points fetch error:", error);
    }
  };

  const fetchHistoryData = async () => {
    try {
      if (!userDetails || !token) return;
      const response = await ChatGptHistory(userDetails, token);
      const data = response.data;
      if (data?.data) {
        const decrypted = decryptData(data.data);
        if (decrypted) {
          setHistory(decrypted);
        }
      }
    } catch (error) {
      console.error("Points fetch error:", error);
    }
  };

  // Added: File handling functions
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Blob URL create karein preview ke liye
      const blobUrl = URL.createObjectURL(file);

      setFileContent(blobUrl); // Agar preview ke liye use ho raha hai

      setAttachedFile({
        FileType: file.type,
        FilePath: blobUrl, // Blob URL for preview
        FileName: file.name,
        IsChange: true,
        fileObject: file, // Original file object bhi save karein
      });
    }
  };

  const removeAttachedFile = () => {
    setAttachedFile(null);
    setFileContent("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const triggerFileSelect = () => {
    fileInputRef.current?.click();
  };

  useEffect(() => {
    if (selectHistory !== null) {
      let arr = [];
      selectHistory?.history?.map((item) => {
        let obj = {
          prompt: item?.CustomerMessage,
          content: item?.ResponseMessage,
          fileData: item?.image,
        };
        arr?.push(obj);
      });
      let defaultObj = {
        prompt: "",
        content: "",
        fileData: null, // Added: Initialize file data for default object
      };
      arr?.push(defaultObj);
      setValue(arr);
    }
  }, [selectHistory]);

  useEffect(() => {
    if (shouldRefetchPoints) {
      fetchPointsData();
      fetchHistoryData();
      setShouldRefetchPoints(false); // reset the flag
    }
  }, [shouldRefetchPoints]);

  useEffect(() => {
    fetchCategory();
    fetchSubCategory();
  }, []);

  useEffect(() => {
    const CategoryData = combineCategoriesWithSubcategories(
      category,
      subcategory,
    );
    setCategoryDropdown(CategoryData);
  }, [category?.length, subcategory?.length]);

  const handleChange = (event) => {
    const newContent = event.target.value;
    setTextarea(newContent);
  };

  const handleKeyDown = async (event, index) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      const prompt = textarea;
      const currentFileData = attachedFile; // Added: Capture current file data
      setTextarea("");

      // Added: Clear file attachment after sending
      setAttachedFile(null);
      setFileContent("");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      // Modified: Include file data in the message
      setValue((prev) => [
        ...prev,
        {
          prompt,
          content: "",
          fileData: currentFileData,
        },
      ]);

      try {
        if (!userDetails || !token) return;
        const response = await getMessage(
          userDetails,
          prompt,
          currentFileData,
          selected,
          token,
          selectedOption,
        );
        const data = response.data;
        if (data?.data) {
          const decrypted = decryptData(data.data);
          if (decrypted) {
            setValue((prev) => {
              const updated = [...prev];
              const lastIndex = updated.length - 1;
              updated[lastIndex] = {
                ...updated[lastIndex],
                content: decrypted.ResponseMessage,
              };
              return updated;
            });
            setShouldRefetchPoints(true);
          }
        }
      } catch (error) {
        console.error("API call failed:", error);
        setIsError(true);
      }
    }
  };

  const onNewChat = () => {
    setValue([
      {
        prompt: "",
        content: "",
        fileData: null, // Added: Reset file data
      },
    ]);
    setSelectHistory(null);
    setTextarea("");
    // Added: Clear file attachment on new chat
    setAttachedFile(null);
    setFileContent("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (window.innerWidth < 1080) {
      setSidebar(false);
    }
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [value?.length]);

  return (
    <>
      <div className="wrapper">
        <Sidebar
          points={points}
          sidebar={sidebar}
          setSidebar={setSidebar}
          onNewChat={onNewChat}
          history={history}
          setSelectHistory={setSelectHistory}
          selectHistory={selectHistory}
          categoryDropdown={categoryDropdown}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
        />
        <div className="main-area">
          <Header
            points={points}
            userDetails={userDetails}
            token={token}
            setShowModal={setShowModal}
            setSelected={setSelected}
            selected={selected}
            categoryDropdown={categoryDropdown}
            setSelectedOption={setSelectedOption}
            selectedOption={selectedOption}
            setIsPurchase={setIsPurchase}
            setIsPointHistory={setIsPointHistory}
          />
          <div
            className="Main-content-class"
            style={{ display: value?.length === 1 ? "flex" : "block" }}
          >
            {value?.length > 1 && (
              <div
                className="main-content"
                ref={scrollRef}
                style={{
                  justifyContent: "flex-start",
                  height: "88%",
                  overflowY: "auto",
                }}
              >
                {value?.map((item, index) => {
                  if (item?.prompt) {
                    return (
                      <div key={index} className="item-container">
                        <div className="right">
                          <div className="text-right">
                            <span>{item?.prompt}</span>

                            {/* Added: Display attached file info in chat */}
                            {item?.fileData && (
                              <div
                                className="attached-file-info"
                                style={{
                                  marginTop: "8px",
                                  padding: "8px",
                                  backgroundColor: "#f0f0f0",
                                  borderRadius: "4px",
                                  fontSize: "12px",
                                  color: "#666",
                                }}
                              >
                                <img
                                  src={IMAGE_URL + item?.fileData}
                                  alt="attachment"
                                  style={{
                                    maxWidth: "100px",
                                    maxHeight: "100px",
                                    display: "block",
                                    marginBottom: "4px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        {item?.content && (
                          <div className="left">
                            <div className="text-left">
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: item?.content.replace(
                                    /\n/g,
                                    "<br />",
                                  ),
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {item?.content === "" && (
                          <div class="chatgpt-loading">
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        )}
                      </div>
                    );
                  }
                })}
              </div>
            )}
            <div
              className={`main-content ${value?.length === 1 ? "text-main-content" : ""}`}
              style={{
                justifyContent: value?.length === 1 ? "center" : "end",
                height: value?.length === 1 ? "100%" : "12%",
                marginBottom: "10px",
              }}
            >
              {/* {value?.length === 1 && <h3 className='first-header'>How can I help you today?</h3>} */}

              {/* Added: File attachment display */}
              {attachedFile && (
                <div
                  className="attached-file-preview"
                  style={{
                    margin: "10px 0",
                    padding: "10px",
                    backgroundColor: "#e8f4fd",
                    border: "1px solid #b3d9f7",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "8px" }}>📎</span>
                    <div>
                      <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                        {attachedFile.FileName}
                      </div>
                      <div style={{ fontSize: "12px", color: "#666" }}>
                        {attachedFile.FileType}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={removeAttachedFile}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "16px",
                      color: "#999",
                    }}
                  >
                    ✕
                  </button>
                </div>
              )}

              {/* 
              <div className="input-container" style={{ position: 'relative' }}>
                <textarea
                  value={textarea}
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(e) => handleKeyDown(e)}
                  placeholder="What do you want to know?"
                  rows={3}
                />
                <button
                  type="button"
                  onClick={triggerFileSelect}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    bottom: '10px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '18px',
                    padding: '5px',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  title="Attach file"
                >
                  <PiPaperclip size={25} />
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileSelect}
                  style={{ display: 'none' }}
                  accept="image/*"
                />
              </div> 
              */}
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <Plan
          token={token}
          userDetails={userDetails}
          setShowModal={setShowModal}
          setShouldRefetchPoints={setShouldRefetchPoints}
        />
      )}

      {IsPointHistory && (
        <PointHistory
          token={token}
          userDetails={userDetails}
          setIsPointHistory={setIsPointHistory}
        />
      )}

      {IsPurchase && (
        <PurchaseHistory
          token={token}
          userDetails={userDetails}
          setIsPurchase={setIsPurchase}
        />
      )}

      {IsError && <Warning setIsError={setIsError} />}
    </>
  );
};

export default ChatGPTMain;
